export default "__VITE_ASSET__QeA9STl4__"